const OSM_WIKI_BASE_URL = "https://wiki.openstreetmap.org/wiki";
const FREE_FORM_TAG_KEYS = [
  /^(?:.*:)?(?:name|.*_name)(?::.*)?$/,
  /^addr:/,
  /^contact:/,
  /^(?:.*:)?(?:website|url|phone|fax|email)$/,
  /^(?:facebook|instagram|twitter|mastodon|linkedin|youtube|flickr|vk|telegram|whatsapp|tiktok|pinterest|foursquare)$/,
  /^(?:.*:)?(?:wikipedia|wikidata|wikimedia_commons|image|mapillary)$/,
  /^(?:ref|ref:.*|.*:ref(?::.*)?|.*_ref)$/,
  /^(?:description|note|fixme|source)(?::.*)?$/,
  /^(?:brand|operator|owner|network)(?::.*)?$/,
  /^(?:architect|artist|manufacturer|model|subject|taxon|genus|species)$/,
  /^(?:destination|inscription)(?::.*)?$/,
  /^(?:postal_code|postcode)$/,
  /^(?:.*:)?colour$/,
  /^(?:opening_hours|collection_times|service_times)$/,
  /^(?:check_date|start_date|end_date|opening_date|survey:date)(?::.*)?$/,
];

export function osmWikiKeyHref(key: string): string {
  return `${OSM_WIKI_BASE_URL}/Key:${encodeURIComponent(key)}`;
}

export function osmWikiTagHref(
  key: string,
  value: string,
): string | undefined {
  if (
    value.length === 0 ||
    FREE_FORM_TAG_KEYS.some((pattern) => pattern.test(key)) ||
    /^[+-]?\d+(?:[.,]\d+)?$/.test(value) ||
    /^(?:https?:\/\/|mailto:|tel:)/i.test(value) ||
    value.includes("@") ||
    /\s/.test(value)
  ) {
    return undefined;
  }

  return `${OSM_WIKI_BASE_URL}/Tag:${encodeURIComponent(key)}=${
    encodeURIComponent(value)
  }`;
}
